<template>
	<div
		class="qw-image-uploader-preview-view el-upload-list el-upload-list--picture-card"
		@mouseenter="onMouseEntered"
		@mouseleave="onMouseLeft">
		<div class="el-upload-list__item" :class="{'circle-border-radius': isCircleComputed}">
			<div class="qw-image-uploader-preview-view__preview-container relative" @click="onPreviewContainerClicked">
				<qw-img
					v-show="thumbnailUrlComputed"
					ref="imageView"
					class="el-upload-list__item-thumbnail"
					:qwoachFile="qwoachFileData"
					:src="thumbnailUrlComputed"
					alt=""/>
				<QwImageUploaderSourcePickerView
					v-if="showSourcePicker"
					class="qw-image-uploader-preview-view__source-picker--overlay"
					:pickerSources="pickerSources"
					@sourceSelected="$emit('sourceSelected', $event)"/>
					<div v-else-if="isActionsVisible && !isLoading" class="qw-image-uploader-preview-view__actions-overlay">
						<div class="qw-image-uploader-preview-view__actions-grid">
							<qw-button-icon
								v-for="actionItem in previewActions"
								:key="actionItem.id"
								:icon="actionItem.icon"
								:tooltip="actionItem.tooltip"
								:tooltipPosition="actionItem.tooltipPosition"
								@click.stop="emitAction(actionItem)"/>
						</div>
					</div>
				<LoadingIndicator
					:text="loadingText"
					:isLoading="isLoading"/>
			</div>
		</div>
	</div>
</template>

<script>
import LoadingIndicator from "@/core/components/LoadingIndicator.vue";
import QwImageUploaderSourcePickerView from "@/core/components/Controls/QwImageUploader/QwImageUploaderSourcePickerView.vue";

const ACTIONS_SHOW_DELAY = 50
const ACTIONS_AUTO_HIDE_DELAY = 2500

export default {
	name: "QwImageUploaderPreviewView",
	components: {LoadingIndicator, QwImageUploaderSourcePickerView},
	emits: ["mouseLeft", "sourceSelected", "previewActionClicked"],

	props: {
		isCircleComputed: Boolean,
		showSourcePicker: Boolean,
		pickerSources: {type: Array, default: () => []},
		previewActions: {type: Array, default: () => []},
		thumbnailUrlComputed: String,
		qwoachFileData: Object,
		isLoading: Boolean,
		loadingText: String,
	},

	data() {
		return {
			hideActionsTimeoutId: null,
			isActionsVisible: false,
			showActionsTimeoutId: null,
		}
	},

	beforeUnmount() {
		this.clearHideActionsTimeout()
		this.clearShowActionsTimeout()
	},

	methods: {
		clearHideActionsTimeout() {
			if(this.hideActionsTimeoutId){
				clearTimeout(this.hideActionsTimeoutId)
				this.hideActionsTimeoutId = null
			}
		},

		clearShowActionsTimeout() {
			if(this.showActionsTimeoutId){
				clearTimeout(this.showActionsTimeoutId)
				this.showActionsTimeoutId = null
			}
		},

		emitAction(actionItem) {
			if(!this.isLoading){
				this.hideActions()
				this.$emit("previewActionClicked", {
					action: actionItem,
					qwoachFile: this.qwoachFileData,
				})
			}
		},

		hideActions() {
			this.clearHideActionsTimeout()
			this.clearShowActionsTimeout()
			this.isActionsVisible = false
		},

		onMouseEntered() {
			this.scheduleShowActions()
		},

		onMouseLeft() {
			this.hideActions()
			this.$emit('mouseLeft')
		},

		onPreviewContainerClicked() {
			if(!this.isLoading && !this.showSourcePicker && !this.isActionsVisible){
				this.clearShowActionsTimeout()
				this.showActions()
				this.scheduleHideActions()
			}
		},

		scheduleHideActions() {
			this.clearHideActionsTimeout()
			this.hideActionsTimeoutId = setTimeout(() => {
				this.hideActions()
			}, ACTIONS_AUTO_HIDE_DELAY)
		},

		scheduleShowActions() {
			this.clearShowActionsTimeout()
			this.showActionsTimeoutId = setTimeout(() => {
				this.showActionsTimeoutId = null
				if(!this.isLoading && !this.showSourcePicker){
					this.showActions()
				}
			}, ACTIONS_SHOW_DELAY)
		},

		showActions() {
			this.clearHideActionsTimeout()
			this.isActionsVisible = true
		},
	},
}
</script>

<style lang="scss">
.qw-image-uploader-preview-view {
	&__preview-container {
		display: flex;
		flex: 1;
		align-items: center;
		justify-content: center;
		height: 100%;
		overflow: hidden;
	}

	&__source-picker--overlay {
		position: absolute;
		inset: 0;
		background: rgba(255, 255, 255, 0.92);
		z-index: 100;
	}

	&__actions-overlay {
		position: absolute;
		inset: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(0, 0, 0, 0.45);
		z-index: 2;
		color: #fff;
		font-size: 1.5em;
	}

	&__actions-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 10px;
		width: 84px;
	}
}
</style>
